import { cn } from '@/lib/utils';

interface ScoreBadgeProps {
    score: number;
}

export function ScoreBadge({ score }: ScoreBadgeProps) {
    const isPositive = score > 0;
    const isZero = score === 0;
    return (
        <span className={cn(
            "text-[10px] font-bold px-1.5 py-0.5 rounded-md flex-shrink-0",
            isZero ? "text-slate-400 bg-slate-50" : isPositive ? "text-emerald-700 bg-emerald-50" : "text-red-600 bg-red-50"
        )}>
            {isPositive ? '+' : ''}{score.toFixed(1)}
        </span>
    );
}
